// src/constants/reservationStatus.js
// Statuts des réservations - NE PAS MODIFIER

export const RESERVATION_STATUS = {
    NEW: 'new',               // Nouvelle demande (juste reçue)
    CONTACTED: 'contacted',   // Admin a contacté le client
    CONFIRMED: 'confirmed',   // Réservation confirmée
    CANCELLED: 'cancelled',   // Annulée
    ARCHIVED: 'archived',     // Archivée (ancienne)
  };
  
  // Labels pour affichage
  export const RESERVATION_STATUS_LABELS = {
    new: 'Nouvelle demande',
    contacted: 'Contacté',
    confirmed: 'Confirmé',
    cancelled: 'Annulée',
    archived: 'Archivée',
  };
  
  // Couleurs pour chaque statut
  export const RESERVATION_STATUS_COLORS = {
    new: '#4299E1',        // Bleu
    contacted: '#ED8936',  // Orange
    confirmed: '#48BB78',  // Vert
    cancelled: '#F56565',  // Rouge
    archived: '#4A5568',   // Gris
  };
  
  // Transitions autorisées
  export const RESERVATION_TRANSITIONS = {
    new: ['contacted', 'cancelled'],
    contacted: ['confirmed', 'cancelled'],
    confirmed: ['cancelled', 'archived'],
    cancelled: ['archived'],
    archived: [],  // Pas de transition depuis archived
  };
  
  // Qui peut modifier le statut?
  export const RESERVATION_MODIFIERS = {
    new: ['SUPER_ADMIN', 'ADMIN', 'SUPPORT'],
    contacted: ['SUPER_ADMIN', 'ADMIN', 'SUPPORT'],
    confirmed: ['SUPER_ADMIN', 'ADMIN', 'OWNER'],
    cancelled: ['SUPER_ADMIN', 'ADMIN', 'SUPPORT'],
    archived: ['SUPER_ADMIN', 'ADMIN'],
  };
  
  // Informations à collecter pour chaque réservation
  export const RESERVATION_FIELDS = {
    clientName: {
      required: true,
      label: 'Nom complet',
      type: 'text',
    },
    clientPhone: {
      required: true,
      label: 'Téléphone ou WhatsApp',
      type: 'tel',
    },
    clientEmail: {
      required: false,
      label: 'Email',
      type: 'email',
    },
    checkInDate: {
      required: true,
      label: 'Date d\'arrivée',
      type: 'date',
    },
    checkOutDate: {
      required: false,
      label: 'Date de départ',
      type: 'date',
    },
    message: {
      required: false,
      label: 'Message',
      type: 'textarea',
    },
    numberOfGuests: {
      required: false,
      label: 'Nombre de personnes',
      type: 'number',
    },
  };